module.exports = {
  src: __webpack_public_path__ + "logo-eamsp-120f97e3d9db7146c103a9820e8187e8.svg",
  width: 147,
  height: 72,
  bytes: 19051,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-eamsp-120f97e3d9db7146c103a9820e8187e8.svg";
};